import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import ProjectStatus from './Project';
import GlobalStatus from './Global';
import { isProjectScope, type VulnIssue } from '../../../../../shared/issuesV2';

/**
 * Display the issue details status base on the project scope (project or global).
 */
const IssueDetailsStatus: VoidFunctionComponent = () => {
  const scope = useSelector(IssuesV2Store.selectors.getScope);
  const activeIssue = useSelector(IssuesV2Store.selectors.getIssueDetails) as VulnIssue;
  if (!activeIssue) {
    return null;
  }

  return isProjectScope(scope)
    ? <ProjectStatus />
    // Release groups will also use the global scope component due to their similarities.
    : <GlobalStatus />;
};

export default IssueDetailsStatus;
